// Split presentation only: preserve card references, group IDs and drag indexes.
export const buildHandRows = (groups) => {
    if (!Array.isArray(groups)) return [];
    const cards = groups.flatMap(group => group.map((card, index) => ({ card, index })));
    if (!cards.length) return [];
    const split = Math.ceil(cards.length / 2);
    return [cards.slice(0, split), cards.slice(split)].filter(row => row.length).map(row => {
        const segments = [];
        row.forEach(item => {
            const previous = segments[segments.length - 1];
            if (previous && previous[0].card.group === item.card.group) previous.push(item);
            else segments.push([item]);
        });
        return { segments, units: row.length + segments.length * 0.6 };
    });
};
